module.exports = __webpack_public_path__ + "media/images/bg/panorama-01eb65701822ef2b2e4750f395f16449.svg";